import { useQuery } from '@tanstack/react-query';
import { getSignatureSlots } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const buildSignatureSlotsQueryKey = (args: {
	dealId: string;
	programmeId: string;
	templateId: string;
}): string =>
	formatUnicorn(
		API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_MASTER_DOCUMENTS_TEMPLATEID_SIGNATURE_SLOTS_GET,
		{ dealId: args.dealId, programmeId: args.programmeId, templateId: args.templateId }
	);

export const useSignatureSlotsQuery = (templateId: string | null, enabled = true) => {
	const { dealId, mipId } = useRequiredParams('dealId', 'mipId');

	const key = buildSignatureSlotsQueryKey({
		dealId,
		programmeId: mipId,
		templateId: templateId ?? '',
	});

	return useQuery({
		queryKey: [key],
		queryFn: () => getSignatureSlots(dealId, mipId, templateId ?? ''),
		enabled: !!templateId && enabled,
	});
};
